import { makeUseFetchOne } from '@elentari/core'
import { cotacoesRepository } from './cotacoesRepository'
import { CotacaoDetail } from '../types'

export const useCotacao = makeUseFetchOne<CotacaoDetail, string>({
  fetch: cotacoesRepository.fetchOne
})
